import Cookies from "js-cookie";

export function getToken() {
    return Cookies.get("satoken");
}

export function clearAuth() {
    // 本地域名版本
    Cookies.remove("satoken");
    Cookies.remove("satoken", { path: "/" });

    // 生产域名版本
    Cookies.remove("satoken", { path: "/", domain: ".slidesorator.com" });
}

export function setsaToken(token) {
    console.log("设置的token:" + token);

    const isProd = process.env.NODE_ENV === "production";

    return Cookies.set("satoken", token, {
        domain: isProd ? ".slidesorator.com" : undefined,
        path: "/",
        secure: isProd ? true : false,
        sameSite: isProd ? "None" : "Lax",
    });
}

export function removeToken() {
    return Cookies.remove('satoken', {
        domain: process.env.NODE_ENV === 'production' ? '.slidesorator.com' : '', // 生产环境使用主域，本地不指定
        path: '/',
    });
}
export const removeNbsp = (str) => {
    return str.replace(/&nbsp;/g, '')
}
export function removeUserInfo() {
    return Cookies.remove('USER');
}

export function getlanguage() {
    return Cookies.get('LANG');
}

export function setlanguage(lang) {
    return Cookies.set('LANG', lang)
}

export function setPermi(id) {
    return Cookies.set('PermiId', id)
}

export function getPermi() {
    return Cookies.get('PermiId')
}

export function setMid(Mid) {
    return Cookies.set('Mid', Mid)
}

export function getMid() {
    return Cookies.get('Mid')
}



export function setUserInfo(userInfo) {
    return Cookies.set('USER', JSON.stringify(userInfo));
}

export function getUserInfo() {
    let user = Cookies.get('USER')
    if (user) {
        return JSON.parse(user);
    } else {
        return {}
    }
}


export function getGuide() {
    return Cookies.get('guide');
}

export function setGuide(guide) {
    return Cookies.set('guide', guide)
}
